import React, { ReactElement, useState, useEffect } from 'react';
import { Button, Col, Form, Modal, Row } from 'react-bootstrap';
import { useRecoilState } from 'recoil';
import { etatModalAvisAbonnement } from '../../../State';
import { DateTime } from 'luxon';
import { useAlertDialog } from '../../../Utils/dialogContext';
import api from '../../../Utils/api';
import { BaseClientEntite } from '../Contacts/DetailsContact';

export type PropsModalAvisAbonnement = {
    clients?: BaseClientEntite[];
};

export interface EtatModalAvis {
    contactId?: string;
    clientsAssocies: BaseClientEntite[];
    afficher: boolean;
}

export default function ModalAvisAbonnement(props: PropsModalAvisAbonnement): ReactElement {
    const bsAlert = useAlertDialog();
    const [etatModal, setEtatClientsAssocies] = useRecoilState(etatModalAvisAbonnement);
    const clients = props.clients ? props.clients : etatModal.clientsAssocies;

    const [selectedClients, setSelectedClients] = useState<Set<string>>(new Set());

    useEffect(() => {
        if (etatModal.afficher && selectedClients.size === 0) {
            const initialSelected = new Set(clients.map((client) => client.id?.toString() || ''));
            setSelectedClients(initialSelected);
            console.log('Initial selected clients:', Array.from(initialSelected));
        }
    }, [etatModal.afficher, clients, selectedClients]);

    async function soumettreAvisAbonnement() {
        try {
            if (selectedClients.size === 0) {
                bsAlert('vous devez au moins selectionner un client', 'warning');
            } else {
                const idClients = {
                    ids: Array.from(selectedClients),
                };
                const reponse = await api.patch('/contacts/abonnement/' + etatModal.contactId, {
                    idClients,
                });
                setEtatClientsAssocies({ contactId: '', clientsAssocies: [], afficher: false });
                bsAlert(reponse.data.message, 'success');
            }
        } catch (_) {
            setEtatClientsAssocies({ contactId: '', clientsAssocies: [], afficher: false });
            bsAlert("Erreur dans l'envoi de l'avis d'abonnement", 'danger');
            // todo : parse error
        }
    }

    function handleCheckBox(e: React.ChangeEvent<HTMLInputElement>) {
        const clientId = e.target.name;
        if (!clientId) {
            console.log('Client ID is null');
            return;
        }

        const isChecked = e.target.checked;
        console.log(`Checkbox clicked ${clientId} ${isChecked}`);

        setSelectedClients((prevSelected) => {
            const newSelected = new Set(prevSelected);
            if (isChecked) {
                newSelected.add(clientId);
                console.log(`Added client ID: ${clientId}`);
            } else {
                newSelected.delete(clientId);
                console.log(`Removed client ID: ${clientId}`);
            }
            console.log('Updated selected clients:', Array.from(newSelected));
            return newSelected;
        });
    }

    function close() {
        setEtatClientsAssocies({ contactId: '', clientsAssocies: [], afficher: false });
    }

    return (
        <>
            <Form>
                <Modal show={etatModal.afficher} keyboard={false} size="lg" onHide={close}>
                    <Modal.Header closeButton>
                        <Modal.Title>Selectionner un client</Modal.Title>
                    </Modal.Header>

                    <Modal.Body>
                        {clients?.map((value) => (
                            <Row key={value.id}>
                                <Col lg={3}>
                                    <Form.Check.Label>Nom: {value.name}</Form.Check.Label>
                                </Col>
                                <Col lg={8}>
                                    Date de fin d&apos;abonnement :
                                    {value.fin_abonnement != null
                                        ? DateTime.fromISO(value.fin_abonnement).toISODate()
                                        : 'Information non disponible'}
                                </Col>
                                <Col>
                                    <Form.Check
                                        type="checkbox"
                                        id={`checkbox-${value.id}`}
                                        name={value.id?.toString() || ''}
                                        onChange={handleCheckBox}
                                        checked={selectedClients.has(value.id?.toString() || '')}
                                    />
                                </Col>
                            </Row>
                        ))}
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={() => close()}>
                            Annuler
                        </Button>
                        <Button variant="primary" onClick={() => soumettreAvisAbonnement()}>
                            {' '}
                            Soumettre
                        </Button>
                    </Modal.Footer>
                </Modal>
            </Form>
        </>
    );
}
